import { apiClient } from '@/lib/api-client';
import { ApiResponse } from '@/types';

export type PassoChave = 'departamentos' | 'cargos' | 'usuarios' | 'projetos' | 'organogramas' | 'fluxogramas';

export interface PrimeirosPassosStatus {
  concluido_em: string | null;
  contagens: Record<PassoChave, number>;
}

const erro = <T,>(error: unknown, mensagem: string): ApiResponse<T | null> => ({
  success: false,
  error: error instanceof Error ? error.message : mensagem,
  data: null,
});

export const primeirosPassosService = {
  async getStatus(): Promise<ApiResponse<PrimeirosPassosStatus | null>> {
    try {
      return await apiClient.get<ApiResponse<PrimeirosPassosStatus>>('/primeiros-passos');
    } catch (error) {
      return erro<PrimeirosPassosStatus>(error, 'Erro ao buscar primeiros passos');
    }
  },

  async concluir(): Promise<ApiResponse<{ concluido_em: string | null } | null>> {
    try {
      return await apiClient.post<ApiResponse<{ concluido_em: string | null }>>('/primeiros-passos/concluir', {});
    } catch (error) {
      return erro<{ concluido_em: string | null }>(error, 'Erro ao concluir primeiros passos');
    }
  },

  async reabrir(): Promise<ApiResponse<{ concluido_em: string | null } | null>> {
    try {
      return await apiClient.post<ApiResponse<{ concluido_em: string | null }>>('/primeiros-passos/reabrir', {});
    } catch (error) {
      return erro<{ concluido_em: string | null }>(error, 'Erro ao reabrir primeiros passos');
    }
  },
};
